// This section name, must match the name coming from partner-orchestrator
export const RISK_PROFILE_SECTION_NAME = 'Risk Considerations';

export const RISK_PROFILE_EDIT_HISTORY_HIDDEN_ATTRIBUTES = [
  'InsiderDetail/id',
  'adverseInformation.mitigationOfRisk',
  'adverseInformation/mediaScreening.mediaScreeningAlerts',
  'adverseInformation/nameScreening.hasMatchHit',
  'adverseInformation/nameScreening.nameScreeningAlerts',
  'adverseInformation/mediaScreening.hasMatchHit',
  'insiderInformation.insiderDetails',
  'MediaScreeningAlert/alertId',
  'MediaScreeningAlert/isAlertOpen',
  'MediaScreeningEvidence/articleId',
  'MediaScreeningEvidence/articlePublicationDate',
  'MediaScreeningEvidence/articleTitle',
  'MediaScreeningEvidence/category',
  'MediaScreeningEvidence/evidenceId',
  'MediaScreeningEvidence/evidenceStatus',
  'MediaScreeningEvidence/externalEvidenceId',
  'MediaScreeningEvidence/isEvidenceOpen',
  'MediaScreeningAlert/closingDate',
  'MediaScreeningEvidence/note',
  'MediaScreeningEvidence/rmAssessment',
  'MediaScreeningEvidence/approvalDate',
  'MediaScreeningEvidence/hitId',
  'NameScreeningAlert/alertId',
  'NameScreeningAlert/isAlertOpen',
  'NameScreeningAlert/closingDate',
  'NameScreeningEvidence/category',
  'NameScreeningEvidence/evidenceId',
  'NameScreeningEvidence/evidenceStatus',
  'NameScreeningEvidence/hitId',
  'NameScreeningEvidence/isEvidenceOpen',
  'NameScreeningEvidence/approvalDate',
  'NameScreeningEvidence/note',
  'NameScreeningEvidence/rmAssessment',
  'NameScreeningEvidence/articleId',
  'NameScreeningEvidence/articlePublicationDate',
  'NameScreeningEvidence/articleTitle',
  'NameScreeningEvidence/externalEvidenceId',
  'mediaScreeningEvidences',
  'nameScreeningEvidences',
  'Evidence/id',
  'evidenceDocument.agreementId',
  'evidenceDocument.uploadBy',
  'evidenceDocument.uploadDate',
  'evidenceDocument.documentName',
  'pep.evidences',
  'adverseInformation/supportingDocuments/0.id',
  'adverseInformation/supportingDocuments/0.agreementId',
];
